<script>
import Layout from "../../layouts/print";
import appConfig from "@/app.config";
import { paymentService } from "../../../services/paymentservice/payment.service";

/* eslint-disable no-console */
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout,
    },
  data() {
    return {
     
      allData: {}

    };
  },
  mounted() {
    this.loadData(this.$route.params.id);
    
  },

  methods:{
    loadData: function(id){
      paymentService.getReceipt(id).then(response => {
        this.allData = response.data;
        console.log(JSON.stringify(this.allData));
      });
    },

    isAsciiOnly(str) {
        for (var i = 0; i < str.length; i++)
            if (str.charCodeAt(i) <= 127)
                return true;
        return false;
    },

    formatCurrency_old(value) {

      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },
    formatCurrency(value, sign='$', decimal='.00') {
      if(value < 0) {
        return "(" + this.$options.filters.numFormat(Math.abs(value), `${sign}0,0${decimal}`) + ")";
      } else {
        return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
      }
    }

  }
};
</script>

<template>
  <Layout>
    <center>
      <div class="col dblue box-a5-v">
        <table width="100%" class="bottom content-general">
          <tr>
            <td width="12%"><p>&nbsp;</p></td>
            <td width="88%"><p>&nbsp;</p></td>
          </tr>
          <tr>
            <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
            <td>
              <p class="khm h6">លំនៅឋាន <span class="g-color">អេចស៊ី</span> ឯ.ក</p>
              <p class="enb h6">LOMNOV THAN <span class="g-color">HC</span> CO., LTD</p>
              <p class="khs h7">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
              <p class="khs h7"><b>ទូរស័ព្ទលេខៈ</b> 015 55 40 77 | 078 55 40 77 <b>Email:</b> account@h-residence.net</p>
            </td>
          </tr>
          <tr><td colspan="2"><div class="hr-2"></div></td></tr>
        </table>
        <table width="100%">
          <tr>
            <td width="30%"></td>
            <td width="40%"></td>
            <td width="30%"></td>
          </tr>
          <tr>
            <td><p></p></td>
            <td class="center">
              <p class="h6 khm">បង្កាន់ដៃទទួលប្រាក់</p>
              <p class="h6 enb"><u>OFFICIAL RECEIPT</u></p>
            </td>
            <td class="right">
              <p class="enb h7">No:{{allData && allData.code}}</p>
              <p class="khs h6">ថ្ងៃទី{{allData.pay_date && allData.pay_date.day}} ខែ{{allData.pay_date && allData.pay_date.month}} ឆ្នាំ{{allData.pay_date && allData.pay_date.year}}</p>
            </td>
          </tr>
        </table>
        <table class="receipt-table receipt-content h6 left" width="100%">
          <tr>
            <td class="row">
              <p class="khs" style="width:11cm;">បានទទួលពី / Received From: 
                <span v-if="isAsciiOnly(allData.payer_name)" class="en">{{allData && allData.payer_name}}</span>
                <span v-else class="khs">{{allData && allData.payer_name}}</span>
                <span v-if="allData.have_partner"> & 
                  <span v-if="isAsciiOnly(allData.payer_name)" class="en">{{allData && allData.partner_name}}</span>
                  <span v-else class="khs">{{allData && allData.partner_name}}</span>
                </span></p>
              <p class="khs" style="width:7cm;"><span class="white">│</span> លេខទូរស័ព្ទ / Phone: {{allData && allData.payer_phone}}</p>
            </td>
          </tr>
          <tr>
            <td class="row">
              <p class="khs" style="width:9cm;">ចំនួនទឹកប្រាក់ / Amount: <span class="khs ">{{allData && formatCurrency(allData.paid)}}</span></p>
              <p class="khs" style="width:9cm;"><span class="white">│</span> ប្រាក់ពិន័យ / Penalty: <span class="khs ">{{allData && formatCurrency(allData.penalty)}}</span></p>
              
            </td>
          </tr>
          <tr>
            <td class="row">
              <p class="khs" style="width:9cm;">បញ្ជុះតម្លៃ / Discount: <span class="khs ">{{allData && formatCurrency(allData.discount)}}</span></p>
              <p class="khs" style="width:9cm;"><span class="white">│</span> សរុប / Amount: {{allData && formatCurrency(allData.total_pay)}}</p>
            </td>
          </tr>
          <tr>
            <td class="row"><p class="khs" style="width:18cm;">ចំនួនទឹកប្រាក់ជាអក្សរ / Amount In Word:  {{allData && `${allData.paid_word} (${allData.paid_word_en})`}}</p></td>
          </tr>
          <tr>
            <td class="row">
              <p class="khs" style="width:7cm;">គម្រោង / Project: {{allData && allData.project}}</p>
              <p class="khs" style="width:5.5cm;"><span class="white">│</span> យូនីតលេខ / Unit# {{allData && allData.unit}}</p>
              <p class="khs" style="width:5.5cm;"><span class="white">│</span> ជាន់ទី / Floor# {{allData && allData.floor}}</p>
            </td>
          </tr>
          <tr>
            <td class="row"><p class="khs" style="width:18cm;">ការពិពណ៌នា / Description: {{allData && allData.notation}}</p></td>
          </tr>
          <tr>
            <td class="row">
              <p class="khs" style="width:11cm;">កាលបរិច្ឆេទបង់បន្ទាប់ / Next Payment Schedule: {{allData && allData.next_pay_date}}</p>
              <p class="khs" style="width:7cm;"><span class="white">│</span> ទឹកប្រាក់ត្រូវបង់បន្ទាប់ / Amount: {{formatCurrency(allData.next_pay)}}</p>
            </td>
          </tr>
          <tr>
            <td class="row">
              <p class="khs h7" style="width:7.2cm;">វិធីទូទាត់ / Payment Method:  <span v-if="allData.payment_method_id==1"  class="h6">&#x2611;</span><span v-else  class="h5">&squ;</span>សាច់ប្រាក់ / Cash</p>
              <p class="khs h7" style="width:4.28cm;"><span class="white">│</span><span v-if="allData.payment_method_id==2"  class="h6">&#x2611;</span><span v-else  class="h5">&squ;</span>មូលប្បទានប័ត្រ / Cheque </p>
              <p class="khs h7" style="width:6.5cm;"><span class="white">│</span><span v-if="allData.payment_method_id==3"  class="h6">&#x2611;</span><span v-else  class="h5">&squ;</span>ផ្ទេរចូលគណនីធនាគារ / Bank Transfer</p>
            </td>
          </tr>
        </table>
        <table width="100%" class="center top">
          <tr>
            <td width="33%"><p class="khm h7">អ្នកគ្រប់គ្រង / <span class="en">Manager</span> 
              <br><br><br>
              . . . . . . . . . . . . . . . . . . . . . . . .
              </p></td>
            <td width="33%"><p class="khm h7">អ្នកទូទាត់ប្រាក់ / <span class="en">Payer</span> 
              <br><br><br>
              . . . . . . . . . . . . . . . . . . . . . . . .
              </p></td>
            <td width="33%"><p class="khm h7">អ្នកទទួលប្រាក់ / <span class="en">Received By</span> 
              <br><br><br>
              {{allData.reciver_name}}
              </p></td>
          </tr>
        </table>
        <table width="100%" class="top">
          <tr>
            <td>
              <p class="khs h7"><b>បញ្ជាក់ / Confirmed:   ប្រាក់ដែលបានបង់រួចហើយ មិនអាចដកយកវិញបានទេ (Money already paid is non-refundable.)</b></p>
            </td>
          </tr>
        </table>
      </div>
    </center>
  </Layout>
</template>